import { render, staticRenderFns } from "./inlineLoading.vue?vue&type=template&id=b23168ba"
import script from "./inlineLoading.vue?vue&type=script&lang=js"
export * from "./inlineLoading.vue?vue&type=script&lang=js"
import style0 from "./inlineLoading.vue?vue&type=style&index=0&id=b23168ba&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports